var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.btnColor},[_vm._t("default"),(_vm.cartIcon)?_c('img',{attrs:{"src":require("../../assets/images/cart.svg"),"alt":"Cart Icon"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }